import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useParams } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import PainelTriagem from './view/paineltriagem';
import PainelAtendimento from './view/painelatendimento';
import Home from './view/home';
import HospitalError from './view/error';
import { HospitalProvider } from './contexts/HospitalContext';
import { getHospitalToken } from './server/authent';
import './App.css';

const theme = createTheme({
  typography: {
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Arial, sans-serif',
    fontSize: 16,
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          padding: '14px 20px',
          borderColor: '#e2e8f0',
        },
        head: {
          fontSize: '0.8rem',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          backgroundColor: '#1e3a5f',
          color: '#ffffff',
          padding: '16px 20px',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-child td': { border: 0 },
        },
      },
    },
  },
});

function HospitalLayout() {
  const { hospital } = useParams();
  const [token, setToken] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let isMounted = true;

    async function loadHospitalToken() {
      setStatus('loading');
      setToken(null);

      try {
        const resolvedToken = await getHospitalToken(hospital);

        if (!isMounted) {
          return;
        }

        if (!resolvedToken) {
          setStatus('not-found');
          return;
        }

        setToken(resolvedToken);
        setStatus('ready');
      } catch (error) {
        if (!isMounted) {
          return;
        }

        setStatus('error');
      }
    }

    loadHospitalToken();

    return () => {
      isMounted = false;
    };
  }, [hospital]);

  if (status === 'loading') {
    return (
      <main className="error-container">
        <div className="loading-card">
          <h1 className="error-title">Carregando unidade</h1>
          <p className="error-message">Consultando credenciais da unidade informada.</p>
        </div>
      </main>
    );
  }

  if (status === 'error') {
    return (
      <HospitalError
        hospital={hospital}
        title="Falha ao consultar credenciais"
        message="Nao foi possivel validar a unidade no momento."
        hint="Tente novamente em alguns instantes. Se o problema persistir, verifique a API de clientes."
      />
    );
  }

  if (status === 'not-found') {
    return <HospitalError hospital={hospital} />;
  }

  return (
    <HospitalProvider value={{ hospital, token }}>
      <Outlet />
    </HospitalProvider>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/:hospital" element={<HospitalLayout />}>
            <Route index element={<Home />} />
            <Route path="triagem" element={<PainelTriagem />} />
            <Route path="atendimento" element={<PainelAtendimento />} />
          </Route>
          <Route path="/" element={<Navigate to="/apresentacao" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
